<template>
  <b-container class="d-flex flex-column mh-100" fluid>
    <div
      class="pagetitle-container d-flex justify-content-start align-items-center"
    >
      <div class="page-title">
        <h2>
          Plánované odstávky
          <small>({{ count }})</small>
        </h2>
      </div>
      <div class="d-flex flex-grow-1">
        <input-filter
          ref="filter"
          :options="filterOptions"
          @onReset="resetFilter"
          @onSearch="search"
        />
      </div>
      <div v-if="$root.user.isAdmin" class="ml-3">
        <b-btn
          class="text-uppercase"
          size="lg"
          variant="primary"
          @click="openAddDowntimeModal"
        >
          <b-icon class="mr-1" icon="plus" scale="1.5x" />
          Nová udalosť
        </b-btn>
      </div>
    </div>
    <add-downtime ref="downtimeForm" />
    <div ref="scroll" v-bar class="bar-out">
      <div>
        <server-table
          ref="table"
          :api-request="apiRequest"
          :columns="table.columns"
          :searchable="false"
          :sort-by.sync="table.sortBy"
          sort-desc
          bordered
          hover
          striped
          @refreshed="onLoaded"
        >
          <template #cell(actions)="data">
            <b-dropdown class="btn-p-0" no-caret variant="link">
              <template slot="button-content">
                <b-icon icon="text-indent-left" scale="1.25x" />
              </template>
              <b-dropdown-item @click="edit(data.item.id)">
                <b-icon class="mr-1" icon="pencil-square" />
                Upraviť
              </b-dropdown-item>
              <b-dropdown-item
                class="text-danger"
                @click.prevent="remove(data.item.id)"
              >
                <b-icon class="mr-1" icon="trash" />
                Vymazať
              </b-dropdown-item>
            </b-dropdown>
          </template>
        </server-table>
      </div>
    </div>
  </b-container>
</template>
<script>
import InputFilter from '@/components/InputFilter'
import ServerTable from '@/components/ServerTable'
import AddDowntime from './Add'

export default {
  components: {
    InputFilter,
    ServerTable,
    AddDowntime,
  },
  data() {
    return {
      loading: false,
      table: {
        columns: [
          {
            key: 'actions',
            label: '',
            class: 'th-shrink',
          },
          {
            key: 'description',
            label: 'Udalosť',
            formatter: (value) => value || '-',
            sortableKey: 'description',
            searchable: true,
          },
          {
            key: 'from',
            label: 'Od',
            formatter: (value) =>
              value ? this.$options.filters.formatDateTime(value) : '-',
            sortable: true,
            sortableKey: 'from',
          },
          {
            key: 'to',
            label: 'Do',
            formatter: (value) =>
              value ? this.$options.filters.formatDateTime(value) : '-',
            sortable: true,
            sortableKey: 'to',
          },
        ],
        sortBy: 'from',
        filter: {},
      },
      filterOptions: {
        placeholder: 'Filtrovanie a hľadanie...',
      },
      count: null,
    }
  },
  mounted() {
    this.$root.$on('reloadDowntimesData', this.$refs.table.refresh)
  },
  beforeDestroy() {
    this.$root.$off('reloadDowntimesData')
  },
  methods: {
    apiRequest(params) {
      return this.$api.get('downtimes/get_list', {
        params: { filter: this.table.filter, ...params },
      })
    },
    onLoaded() {
      this.count = this.$refs.table.totalRows
    },
    search() {
      this.$refs.table.searchVal = this.$refs.filter.value
      this.$nextTick(() => {
        this.$refs.table.search()
      })
    },
    resetFilter() {
      this.$refs.table.reset()
    },
    openAddDowntimeModal() {
      this.$root.$emit('modal-show', 'add-downtime')
    },
    edit(id) {
      this.$refs.downtimeForm.edit = true
      this.$refs.downtimeForm.form.id = id
      this.$nextTick(() => {
        this.openAddDowntimeModal()
      })
    },
  },
}
</script>
